<template>
  <div v-if="DepSignUpShow" class="overflow-auto">
    高中職招生宣導資訊目前共 {{ total }}筆<br>
    活動開始日期：{{ sActiveTime }}至活動結束日期{{ eActiveTime }}
                <div style="display: flex">
                  <div style="margin-right: 10px">
                    活動開始日期：<br />
                    <flat-pickr
                      v-model="sActiveTime"
                      :config="flatpickrConfig"
                      ref="flatpickrInstance"
                    ></flat-pickr>
                  </div>

                  <div>
                    活動結束日期：<br />
                    <flat-pickr
                      v-model="eActiveTime"
                      :config="flatpickrConfig"
                      ref="flatpickrInstance"
                    ></flat-pickr>
                  </div>

                  <button
                    href="#"
                    @click.prevent="getStdLoginActiveList(dptcd)"
                    class="btn btn-outline-info"
                    type="button"
                    style="font-size: 14px"
                  >
                    查詢
                  </button>
                  <button
                    href="#"
                    @click.prevent="reset()"
                    class="btn btn-outline-info"
                    type="button"
                    style="font-size: 14px"
                  >
                    清除重來
                  </button>
                </div>


    <b-tabs content-class="mt-3" justified>
      <div
        class="dataTables_scrollBody"
        style="
          font-size: 14px;
          position: relative;
          overflow: auto;
          max-height: 100%;

          border-bottom: 1px solid #111;
          border-top: 1px solid #111;
        "
      >
        <b-table-simple
          class="ncut-table-menu-striped ncut-table-menu"
          responsive
          bgcolor="#FFFFFF"
        >
          <b-thead class="ncut-thead-menu">
            <b-tr>
              <b-th style="min-width: 2em">序號</b-th>
              <b-th style="min-width: 2em">活動編號</b-th>
              <b-th style="min-width: 3em">地區</b-th>
              <b-th style="min-width: 3em">活動名稱</b-th>
              <b-th style="min-width: 5em">活動開始時間</b-th>
              <b-th style="min-width: 5em">活動結束時間</b-th>
              <b-th style="min-width: 2em">本活動小組長</b-th>

              <b-th style="min-width: 2em">本活動宣導人數(名額/已報名)</b-th>
              <b-th style="min-width: 2em">報名狀態</b-th>
              <b-th style="min-width: 5em">活動狀態</b-th>
            </b-tr>
          </b-thead>
          <b-tbody class="ncut-tbody-menu">
            <b-tr
              v-for="(item, index) in filteredDocs"
              :key="item.aid"
              :index="item.aid"
              v-bind:style="{
                background: selectedRowIndex == index ? headerColor : '',
              }"
              @click="selectedRowIndex = index"
            >
              <b-td style="text-align: right">
                {{ (currentPage - 1) * pageSize + index + 1 }}
              </b-td>
              <b-td style="text-align: left">
                {{ item.aid }}
              </b-td>
              <b-td style="text-align: left">
                {{ item.city }}
              </b-td>
              <b-td style="text-align: left"
                >{{ item.activeName }}
                <button
                  href="#"
                  @click="ListActiveDetail3(item.aid, item.sn)"
                  class="btn btn-outline-success"
                  type="button"
                  style="font-size: 14px"
                >
                  活動詳細
                </button>
              </b-td>
              <b-td style="text-align: left">{{ item.sActiveTime }}</b-td>
              <b-td style="text-align: left">{{ item.eActiveTime }}</b-td>
              <b-td style="text-align: left">{{ item.name }}</b-td>

              <b-td style="text-align: left"
                >{{ item.activeNumber }} / {{ item.signUpTotal }}</b-td
              >

              <b-td style="text-align: left"
                >{{ item.isComplete == true ? "已報名" : "未報名" }}
              </b-td>
              <b-td
                v-if="
                  item.timeOpenShow && item.activeNumber - item.signUpTotal > 0
                "
                style="text-align: left"
              >
                <button
                  href="#"
                  @click="ListActiveDetailDep(item.aid, item.sn, item.sActiveTime)"
                  class="btn btn-outline-success"
                  type="button"
                  style="font-size: 14px"
                >
                  報名
                </button>
              </b-td>
              <b-td v-if="item.isComplete" style="text-align: left">
                <button
                  href="#"
                  @click="ListActiveDetail2(item.aid, item.sn)"
                  class="btn btn-outline-success"
                  type="button"
                  style="font-size: 14px"
                >
                  報名詳細
                </button>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
        <b-pagination
          v-model="currentPage"
          :total-rows="total"
          :per-page="pageSize"
          :limit="21"
          v-if="total > pageSize"
        />
      </div>
    </b-tabs>

    <b-modal ref="q-modal" hide-footer title="請注意">
      <div class="d-block text-center">
        <h3>
          【提醒訊息】老師您好：您同一日已報名二場活動，請留意活動時間是否有衝突，若有問題，請來電洽詢分機2707或2708。
        </h3>
      </div>
      <b-button class="mt-3" variant="outline-danger" block @click="cancalRM"
        >取消報名</b-button
      >
      <b-button class="mt-2" variant="outline-info" block @click="confirmRM"
        >報名確認</b-button
      >
    </b-modal>

  </div>
<div v-else>
  <ListActiveDetailDep
      :aid="aid"
      :sn="sn"
      v-if="ListActiveDetailDepShow"
      @hideModal="hideModal('ListActiveDetailDep')"
    />
    <ListActiveDetail2
      :aid="aid"
      :sn="sn"
      v-if="ListActiveDetail2Show"
      @hideModal="hideModal('ListActiveDetail2')"
    />
  <ListActiveDetail3
      :aid="aid"
      :sn="sn"
      v-if="ListActiveDetail3Show"
      @hideModal="hideModal('ListActiveDetail3')"
    />

</div>

</template>
<script>
import * as tools from "../tool";

import ListActiveDetailDep from "@/components/ListActiveDetailDep.vue";
import ListActiveDetail2 from "@/components/ListActiveDetail2.vue";
import ListActiveDetail3 from "@/components/ListActiveDetail3.vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { tw } from "flatpickr/dist/l10n/zh-tw.js";

export default {
  name: "DepSignUpView",
  components: {
    ListActiveDetailDep,
    ListActiveDetail2,
    ListActiveDetail3,
    flatPickr,
  },
  data() {
    return {
      aid: 0,
      sn: null,
      ConflictShow: false,
      TimeOutShow: false,
      DepSignUpShow: true,
      TimeOpenShow: false,
      ListActiveDetailDepShow: false,
      ListActiveDetail2Show: false,
      ListActiveDetail3Show: false,
      memberShow: this.$store.state.user2,
      id: null,
      dptcd:  null,
      gid: null,
      name:  null,
      dptnm:  null,
      em: "",
      content: {
        text1: "",
        text2: "",
      },
      user: {
        id1: "",
        id2: "",
        id3: "",
        sysId: 0, // 學生登入
        isLogin: true,
      },

      // captchaInfo:{text1:'',text2:'',text3:''},
      confirmData: null,
      captchaInfo: null,
      inputData: null,
      inputData2: null,
      sActiveTime: null,
      eActiveTime: null,
      flatpickrConfig: {
        allowInput: true, // 允許手動輸入
        clear: true, // 顯示清除按鈕
        //defaultDate: null, // 清除當前選擇的日期
        enableTime: false,
        weekNumbers: true,
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "Y-m-d",
        time_24hr: false, // 這應該強制使用 12 小時制
        locale: {
          weekdays: {
            shorthand: ["日", "一", "二", "三", "四", "五", "六"],
            longhand: [
              "星期日",
              "星期一",
              "星期二",
              "星期三",
              "星期四",
              "星期五",
              "星期六",
            ],
          },
        },
      },
      queryInfo: {
        aid:null,
        date1:null,
        sActiveTime: null,
        eActiveTime: null,
        schoolName: null,
        dptcdName: null,
        gidName: null,
        updateUser: null,
        updateUserName: null,
        enrollTypeName: null,
      },
      total: 0,
      signUpTotal: 0,
      selectedRowIndex: 0,
      currentPage: 1,
      currentPage2: 1,
      pageSize: 10,
    };
  },
  computed: {
    filteredDocs: function () {
      let data = [];

      if (this.inputData != null) {
        data = this.inputData.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        );
      }
      return data;
    },
    headerColor() {
      return "#f7e8aa";
    },
  },
  methods: {
    reset() {
      let vm = this;

       vm.sActiveTime = null;
       vm.eActiveTime = null;

    },
    getStdLoginActiveList(dptcd) {
      this.DepSignUpShow = true;
      this.TimeOutShow = false;
      this.ListActiveDetailDepShow = false;
      this.ListActiveDetail2Show = false;
      this.ListActiveDetail3Show = false;
      let vm = this;

      if (vm.sActiveTime != null) {
        const dateObject = new Date(vm.sActiveTime);
        // 提取日期部分
        vm.sActiveTime = dateObject.toISOString().split("T")[0];
      }
      if (vm.eActiveTime != null) {
        const dateObject = new Date(vm.eActiveTime);
        // 提取日期部分
        vm.eActiveTime = dateObject.toISOString().split("T")[0];
      }

      this.$http
        .get(
          "./WebApi/HighSchoolEnrolling/GetStdLoginActiveList/".concat(
            vm.id + "/" + dptcd + "/" + vm.sActiveTime  + "/" + vm.eActiveTime
          )
        )
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData = response.data;
            console.log("vm.inputData", vm.inputData);
            vm.total = vm.inputData.length;
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        });
    },
    getALLActiveListTimeOut(dptcd) {
      this.TimeOutShow = true;
      this.DepSignUpShow = false;
      this.ListActiveDetailDepShow = false;
      this.ListActiveDetail2Show = false;
      this.ListActiveDetail3Show = false;
      let vm = this;

      this.$http
        .get(
          "./WebApi/HighSchoolEnrolling/GetALLActiveListTimeOut/".concat(
            vm.id + "/" + dptcd
          )
        )
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData = response.data;
            console.log("vm.inputData", vm.inputData);
            vm.total = vm.inputData.length;
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        });
    },
    hideModal(name) {
      this.ListActiveDetailDepShow = false;
      this.ListActiveDetail2Show = false;
      this.ListActiveDetail3Show = false;
      this.TimeOutShow = false;
      this.getStdLoginActiveList(this.dptcd);
      this.DepSignUpShow = true;
    },

    remove(eid) {
      this.eid = eid;
      this.$refs["q-modal"].show();
    },
    cancalRM() {
      this.$refs["q-modal"].hide();
    },

    confirmRM() {
      this.$refs["q-modal"].hide();
      var vm = this;
      this.$http
        .get("./WebApi/HighSchoolEnrolling/DeleteApplyPDF/".concat(this.eid))
        .then((response) => {
          if (response.data) {
            tools.showAlert(vm, "success", "恭喜您,報名成功");
          } else {
            tools.showAlert(vm, "danger", "對不起,報名失敗");
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, "danger", "網路連線失敗" + error);
        });
    },
    getDateConflict(aid, date1) {

      var vm = this;
      vm.queryInfo.aid = aid;
      vm.queryInfo.date1 = date1;
      vm.queryInfo.updateUser = vm.id;
      this.$http
        .put("./WebApi/HighSchoolEnrolling/GetDateConflict/", this.queryInfo)
        .then((response) => {
          if (response.data > 0) {
            alert(
              "【提醒訊息】老師您好：您同一日已報名二場活動，請留意活動時間是否有衝突，若有問題，請來電洽詢分機2707或2708。"
            );
            // tools.showAlert(
            //   vm,
            //   "success",
            //   "【提醒訊息】老師您好：您同一日已報名二場活動，請留意活動時間是否有衝突，若有問題，請來電洽詢分機2707或2708。"
            // );
            if (response.data == 2) {
              vm.ConflictShow = true; //時間衝突
              return;
            } else {
              vm.ConflictShow = false; //1時間不衝突
              return;
            }
          } else {
            vm.ConflictShow = false; //0時間不衝突
            return;
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, "danger", "網路連線失敗" + error);
        });
    },
    ListActiveDetailDep(aid, sn, date1) {
      var vm = this;

     // this.getDateConflict(aid, date1);

      // 在 getDateConflict 的異步操作完成後執行下面的代碼
    //  if (!this.ConflictShow) {
        this.$nextTick(() => {
          // 這裡可以放置異步操作完成後需要執行的邏輯
          vm.aid = aid;
          vm.sn = sn;
          vm.DepSignUpShow = false;
          vm.TimeOutShow = false;
          vm.ListActiveDetail2Show = false;
          vm.ListActiveDetail3Show = false;
          vm.ListActiveDetailDepShow = true;
        });
    //  }
    },
    ListActiveDetail2(aid, sn) {
      this.aid = aid;
      this.sn = sn;
      this.DepSignUpShow = false;
      this.TimeOutShow = false;
      this.ListActiveDetailDepShow = false;
      this.ListActiveDetail2Show = true;
    },
    ListActiveDetail3(aid, sn) {
      this.aid = aid;
      this.sn = sn;
      this.DepSignUpShow = false;
      this.TimeOutShow = false;
      this.ListActiveDetailDepShow = false;
      this.ListActiveDetail2Show = false;
      this.ListActiveDetail3Show = true;


    },

    logout() {
      alert("登出成功");
      window.location.reload();
      window.location.replace("/");
    },
  },
  created() {
    console.log("======created DepSignUpView =====");
    let vm = this;

if (vm.$store.getters.getAllstate.inputData != null) {
  vm.id = vm.$store.getters.getAllstate.inputData.usrData.id;
  vm.dptcd = vm.$store.getters.getAllstate.inputData.usrData.dptcd;
  vm.gid= vm.$store.getters.getAllstate.inputData.usrData.gid;
   vm.name= vm.$store.getters.getAllstate.inputData.usrData.name;
    vm.dptnm= vm.$store.getters.getAllstate.inputData.usrData.dptnm;
} else {
  vm.id = vm.$store.getters.getAllstate.user.id;
  vm.dptcd = vm.$store.getters.getAllstate.user.dptcd;
  vm.gid= vm.$store.getters.getAllstate.user.gid;
   vm.name= vm.$store.getters.getAllstate.user.name;
    vm.dptnm= vm.$store.getters.getAllstate.user.dptnm;
}

    //this.getTimeSet();
  },
  mounted() {
    console.log("======mounted DepSignUpView  =====");

    this.getStdLoginActiveList(this.dptcd);
  },
};
</script>
<style scoped>
</style>
